import { CircularProgress, Stack, Typography } from '@mui/material'
import { COLORS } from 'app-constants'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import { authenticatedUserAtom } from 'state'

const LoadingSubscription = () => {
  const user = useRecoilValue(authenticatedUserAtom)
  const navigate = useNavigate()

  useEffect(() => {
    if (user?.subscription) {
      navigate('/', { replace: true })
    }
  }, [user?.subscription, navigate])

  return (
    <Stack
      width="100vw"
      height="100vh"
      justifyContent="center"
      alignItems="center"
      sx={{
        background: COLORS.PURE_WHITE,
      }}>
      <Typography variant="h3">Almost there!</Typography>
      <CircularProgress
        size="24px"
        thickness={4}
        style={{ color: COLORS.JELLED_PRIMARY_BLUE, marginTop: '60px', marginBottom: '60px' }}
      />
      <Typography variant="pS">Setting up your account...</Typography>
    </Stack>
  )
}

export default LoadingSubscription
